import { compose, nthArg, prop } from 'ramda';

const fromProps = propName => compose(prop(propName), nthArg(1));

export { fromProps };
